// extracted by mini-css-extract-plugin
export default {"QuarterSection":"Quarter_QuarterSection__6-12I","textStyle":"Quarter_textStyle__PkYqS","downloadCircleDiv":"Quarter_downloadCircleDiv__BGhuR","iconStyle":"Quarter_iconStyle__23ERZ"};